<template>
  <div class="scroll" @mouseover="showImg(1)" @mouseleave="index = ''">
    <img class="img-top" src="@/assets/images/top-active.png" v-if="index === 1" @click="goTop"/>
    <img class="img-top" src="@/assets/images/top.png" v-else/>
  </div>
</template>
<script>
export default {
  data() {
    return {
      index: "",
      showButton: false,
    }
  },
  mounted() {
    window.addEventListener("scroll",this.showbtn,true);
  },
  destroyed() {
    window.removeEventListener("scroll",this.showbtn,true);
  },
  methods: {
    showImg(index) {
      this.index = index
    },
    showbtn(){
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      if(scrollTop > 500) {
        this.showButton = true;
        $(".img-top").addClass("opacity");
         $(".img-top").removeClass("remove-opacity");
      } else {
        this.showButton = false;
        this.index = "";
        $(".img-top").addClass("remove-opacity");
      }
    },
    goTop() {
      var timer = setInterval(() => {
        let osTop = document.documentElement.scrollTop || document.body.scrollTop;
        let ispeed = Math.floor(-osTop / 5); 
        document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed;
        // this.isTop = true;
        if(osTop === 0){
          clearInterval(timer);
        }
      },10)
    }
  }
}
</script>
<style lang="scss" scoped>
img {
  position: fixed;
  right: 50px;
  bottom: 150px;
  z-index: 20;
  cursor: pointer;
  opacity: 0;
  transition: opacity .75s;
}
.opacity {
  opacity: 1;
  transition: opacity .75s;
}
.remove-opacity {
  opacity: 0;
  transition: opacity .75s;
}
</style>


// WEBPACK FOOTER //
// src/components/scroll-top.vue